import { Capacitor } from '@capacitor/core';
import { api } from '../api/client';

/**
 * Уведомления на этом устройстве.
 *
 * Человек, у которого есть и приложение, и браузер, получал о каждом
 * сообщении по два уведомления — причём браузерное приходило даже при
 * закрытой вкладке: в этом и смысл Web Push, он работает без страницы.
 * Поэтому нужен выключатель, отдельный для каждого устройства.
 *
 * Решение хранится здесь же, на устройстве: сервер знает только, слать ли
 * ему уведомления, а «кто именно отказался» его не касается.
 */
const KEY = 'familychat.notifications';

export function notificationsEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'off';
  } catch {
    // Приватный режим или запрещённое хранилище: считаем, что включены
    return true;
  }
}

function remember(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? 'on' : 'off');
  } catch {
    // Не сохранилось — в этом сеансе выключатель всё равно сработает
  }
}

/**
 * Выключает уведомления: убирает подписку в браузере и токен на сервере.
 *
 * Важен порядок: сначала сервер, потом подписка. Если оборвётся связь,
 * лучше остаться с ненужной подпиской, чем с токеном, по которому
 * уведомления продолжат приходить.
 */
export async function disableNotifications(deviceId: string): Promise<void> {
  await api.dropPushToken(deviceId);
  remember(false);

  if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    const subscription = await registration?.pushManager.getSubscription();
    await subscription?.unsubscribe();
  }
}

/**
 * Возвращает уведомления. Подписка оформляется заново при следующем входе
 * или перезагрузке страницы — отдельного вызова не требуется.
 */
export function enableNotifications(): void {
  remember(true);
}
